import React from 'react'; // eslint-disable-line import/no-extraneous-dependencies
import cardStyles from '../../../card.module.css';
import styles from './mainCard.module.css';

const MainCard = () => (
  <div className={cardStyles.card}>
    <div className={styles.container}>
      <div className={`${styles.mainBanner} ${styles.banner}`}>
        <div className={`${styles.bannerSubtitle} ${styles.alignStart}`}>
          <span>In case you were wondering...</span>
        </div>
        <div className={`${styles.bannerTitle} ${styles.alignCenter}`}>
          <span>Yes, we are Twins</span>
        </div>
        <div className={`${styles.bannerSubtitle} ${styles.alignEnd}`}>
          <span></span>
        </div>
      </div>
    </div>
    <div className={styles.descContainer}>
      <div className={`${styles.aboutUs}`}>
        <p className={styles.sectionHeader}>And yes, we do get asked that a lot!</p>
        <p className={styles.sectionParagraph}>
          Welcome to the personal lair of the Rajendran twins!
        </p>
      </div>
    </div>
  </div>
);


export default MainCard;



// WEBPACK FOOTER //
// ./src/pageComponents/home/components/mainCard/index.jsx